import { render, staticRenderFns } from "./wrathOfEgypt.vue?vue&type=template&id=1a9257b3&scoped=true"
import script from "./wrathOfEgypt.vue?vue&type=script&lang=js"
export * from "./wrathOfEgypt.vue?vue&type=script&lang=js"
import style0 from "./wrathOfEgypt.vue?vue&type=style&index=0&id=1a9257b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9257b3",
  null
  
)

export default component.exports